<template>
    <div
        :style="mergedStyles"
        class="o-nav-buttons-block nav-buttons-block"
    >
        <span
            v-if="label"
            class="nav-buttons-block-label"
        >
            {{ "ui.popup.start-nav" | translate }}
        </span>
        <div class="nav-buttons-block-wrapper">
            <ANavModeButton
                :item-id="itemId"
                :mode="$options.FAST"
                :path-name="mergedParams.pathName"
                @onClick="onClick"
            />
            <ANavModeButton
                :item-id="itemId"
                :mode="$options.EASY"
                :path-name="mergedParams.pathName"
                @onClick="onClick"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import ANavModeButton from '../../atoms/a-nav-mode-button';
import {
    FAST,
    EASY
} from "@/utils/constants/app-constants";

export default {
    name: "ONavButtonsBlock",
    props: {
        id: {
            type: Number,
            default: null
        },
        label: {
            type: Boolean,
            default: true
        },
        view: {
            type: String,
            default: ''
        }
    },
    components: {
        ANavModeButton
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        itemId() {
            return this.id || this.$route.query.objectId || this.mergedParams.id;
        },
        configStyles() {
            //TODO: delete ANavButtonsBlock obj from all configs and drop additional checking after all maps will use ONavButtonsBlock name component
            return this.getMapConfigProp('components.ONavButtonsBlock.styles')
                || this.getMapConfigProp('components.ANavButtonsBlock.styles')
                || null;
        },
        viewStyles() {
            return this.getMapConfigProp(`views.${this.view}.params.ONavButtonsBlock.styles`);
        },
        mergedStyles() {
            return {
                ...this.configStyles,
                ...this.viewStyles
            }
        },
        componentParams() {
            //TODO: delete ANavButtonsBlock obj from all configs and drop additional checking after all maps will use ONavButtonsBlock name component
            return this.getMapConfigProp('components.ONavButtonsBlock.params')
                || this.getMapConfigProp('components.ANavButtonsBlock.params')
                || {};
        },
        configParams() {
            //TODO: delete ANavButtonsBlock obj from all configs and drop additional checking after all maps will use ONavButtonsBlock name component
            return this.getMapConfigProp(`views.${this.view}.params.ONavButtonsBlock.params`)
                || this.getMapConfigProp(`views.${this.view}.params.ANavButtonsBlock.params`)
                || {};
        },
        mergedParams() {
            return {
                ...this.componentParams,
                ...this.configParams
            }
        }
    },
    methods: {
        onClick() {
            this.$emit('onClick');
        }
    },
    EASY,
    FAST
}
</script>

<style lang="scss">
@import "theme";
</style>